import { hueFor, initials } from './avatar';
import type { ContactCardData } from './types';

type Contact = ContactCardData['contacts'][number];

/**
 * Rich single-contact card shown when a lookup ("pull up Andre", "who is …")
 * resolves to ONE person. Larger avatar + name + email + a one-line bio, vs the
 * compact grid cell used for multiple matches. The whole card is clickable →
 * onOpen(), which opens the full ContactCardPopover.
 */
export function ContactDetailCard({ contact, onOpen }: { contact: Contact; onOpen: () => void }) {
  const subtitle =
    contact.title && contact.company
      ? `${contact.title} · ${contact.company}`
      : contact.title || contact.company || '';
  const bioLine = contact.bio || subtitle;

  return (
    <button type="button" className="rc-card rc-contact-detail" onClick={onOpen}>
      {contact.email && (
        <span className="rc-cd-action" aria-hidden="true" title="Open contact">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" />
          </svg>
        </span>
      )}
      <div className="rc-cd-row">
        {contact.photoUrl ? (
          <img className="rc-cd-av" src={contact.photoUrl} alt="" />
        ) : (
          <span
            className="rc-cd-av rc-cd-av-initials"
            style={{ background: hueFor(contact.email || contact.name || '?') }}
          >
            {initials(contact.name, contact.email || '')}
          </span>
        )}
        <span className="rc-cd-body">
          <span className="rc-cd-name">{contact.name || contact.email || 'Unknown contact'}</span>
          {contact.email && <span className="rc-cd-email">{contact.email}</span>}
          {bioLine && <span className="rc-cd-bio">{bioLine}</span>}
        </span>
      </div>
    </button>
  );
}
